import { api, unwrap } from '@/shared/lib/api';
import type { AuthUser, Language } from '@/stores/auth.store';

export interface NotificationPrefs {
  orders: boolean;
  promotions: boolean;
  dailyDigest: boolean;
}

export const profileService = {
  async getMe(): Promise<AuthUser> {
    const res = await api.get('/users/me');
    return unwrap<AuthUser>(res.data);
  },
  async update(patch: {
    language?: Language;
    phone?: string;
    firstName?: string;
    lastName?: string;
  }): Promise<Partial<AuthUser>> {
    const res = await api.patch('/users/me', patch);
    return unwrap<Partial<AuthUser>>(res.data);
  },
  async balance(): Promise<{ balance: string; currency: string }> {
    const res = await api.get('/users/me/balance');
    return unwrap(res.data);
  },
  async notificationPrefs(): Promise<NotificationPrefs> {
    const res = await api.get('/users/me/notification-prefs');
    return unwrap<NotificationPrefs>(res.data);
  },
  async updateNotificationPrefs(patch: Partial<NotificationPrefs>): Promise<NotificationPrefs> {
    const res = await api.patch('/users/me/notification-prefs', patch);
    return unwrap<NotificationPrefs>(res.data);
  },
};

export const supportService = {
  async createTicket(subject: string, body: string) {
    const res = await api.post('/support/tickets', { subject, body });
    return unwrap(res.data);
  },
  async listMyTickets() {
    const res = await api.get('/support/tickets');
    return unwrap(res.data);
  },
};
